// MOMENT JS
import momentjs from 'moment';
import 'moment/locale/pt-br';

momentjs.locale('pt-br');

const moment = momentjs;

export default moment;